// Utilization band of an occupancy score, named after what it means rather than its color so the
// palette can change without renaming anything.
export type OccupancyBand = 'under' | 'optimal' | 'nearCapacity' | 'overloaded';

// Occupancy band edges, as percentages
const OPTIMAL_FROM = 80;
const NEAR_CAPACITY_FROM = 92;
const OVERLOADED_FROM = 98;

// The percentage a score is displayed as: a score is a 0..1 ratio, shown with two decimals.
// Both the number the user reads and the band that colors it go through this one rounding, so a
// score of 0.799999999 cannot read "80%" in grey.
export const getDisplayedOccupancyPercentage = (score: number): number => Number((score * 100).toFixed(2));

// Displayed percentage as text, without a trailing ".00", so a whole percentage reads "80" not "80.00"
export const formatOccupancyPercentage = (score: number): string =>
    getDisplayedOccupancyPercentage(score).toFixed(2).replace(/[.,]0+$/, '');

// Classified from the displayed percentage, NOT from the raw score, so the color always agrees with
// the number printed beside it
export const getOccupancyBand = (score: number): OccupancyBand => {
    const percentage = getDisplayedOccupancyPercentage(score);

    if (percentage < OPTIMAL_FROM) {
        return 'under';
    }

    if (percentage <= NEAR_CAPACITY_FROM) {
        return 'optimal';
    }

    if (percentage <= OVERLOADED_FROM) {
        return 'nearCapacity';
    }

    return 'overloaded';
};
